import TopNav from "@/pages/home/components/TopNav";
import Hero from "@/pages/home/components/Hero";
import HotSection from "@/pages/home/components/HotSection";
import DeepPicks from "@/pages/home/components/DeepPicks";
import TruthTimeline from "@/pages/home/components/TruthTimeline";
import StoryFeature from "@/pages/home/components/StoryFeature";
import FaqGuide from "@/pages/home/components/FaqGuide";
import AboutSection from "@/pages/home/components/AboutSection";
import Newsletter from "@/pages/home/components/Newsletter";
import Footer from "@/pages/home/components/Footer";
import BackTop from "@/pages/home/components/BackTop";

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50 text-foreground-950">
      <TopNav />
      <Hero />
      <HotSection />
      <DeepPicks />
      <TruthTimeline />
      <StoryFeature />
      <FaqGuide />
      <AboutSection />
      <Newsletter />
      <Footer />
      <BackTop />
    </main>
  );
}